import type { Sheet } from '../types';

function sheetModifiedTime(sheet: Sheet): number {
  return sheet.lastModified?.getTime() ?? sheet.createdAt.getTime();
}

/**
 * IndexedDB 再読込でメモリ上のシートが消えないよう、ストレージとマージする。
 * 同一 ID は lastModified が新しい方を採用。メモリにのみ存在するシートも保持する。
 */
export function mergeSheetsForState(memorySheets: Sheet[], storageSheets: Sheet[]): Sheet[] {
  const byId = new Map<string, Sheet>();

  for (const sheet of storageSheets) {
    byId.set(sheet.id, sheet);
  }

  for (const mem of memorySheets) {
    const stored = byId.get(mem.id);
    if (!stored) {
      byId.set(mem.id, mem);
      continue;
    }
    if (sheetModifiedTime(mem) >= sheetModifiedTime(stored)) {
      byId.set(mem.id, mem);
    }
  }

  return Array.from(byId.values()).sort(
    (a, b) => b.createdAt.getTime() - a.createdAt.getTime()
  );
}
